module.exports = __webpack_public_path__ + "static/fonts/np_r.b55eca6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/np_r.ttf
// module id = Ytj3
// module chunks = 14